import * as React from "react";
import { useEffect } from "react";
import { Badge, Button, Checkbox, TableCell, TableRow } from "@mui/material";
import moment from "moment/moment";
import { MdEmail, MdPhone } from "react-icons/md";
import StaffVouchersChangeVoucherNumber from "./StaffVouchersChangeVoucherNumber";
import StaffVouchersDetailBox from "./StaffVouchersDetailBox";
import StaffVouchersShowVoucherNumber from "./StaffVouchersShowVoucherNumber";
import StaffVoucherCancelRedemption from "./StaffVoucherCancelRedemption";
import LandingCommunityLogsUpdate from "./Logs/LandingCommunityLogsUpdate";
import StaffVoucherCancelVoucher from "./StaffVoucherCancelVoucher";

export default function StaffVouchersShowTableRow({
  row,
  redeem,
  setLoadingVouchers,
  hideActioned,
  columns,
  version,
  selected = false,
  onSelectRow = () => {},
}) {
  const [showLogsManage, setShowLogsManage] = React.useState(false);
  const [showCreatedAtLogsManage, setShowCreatedAtLogsManage] = React.useState(false);
  const [showCancelRedemption, setShowCancelRedemption] = React.useState(false);
  const [currentRow, setCurrentRow] = React.useState(row);
  const [isOpenRow, setIsOpenRow] = React.useState(false);
  const [isOpenMC, setIsOpenMC] = React.useState(false);
  const [chip, setChip] = React.useState("");
  const date = new Date().toISOString().slice(0, 10);

  useEffect(() => {
    setChip(row.a_microchip_number);
    setCurrentRow(row);
  }, [row]);

  const VoucherStatus = () => {
    const response = row.msg;
    const success_issued = row.api_response_issued === "success";
    const success_redeemed = row.api_response_redeemed === "success";
    
    return (
      <>
        {response === null ? (
          <Badge sx={{ color: "red" }}>Not synced</Badge>
        ) : (
          <>
            {success_issued ? (
              <Badge sx={{ color: "green" }}>Issue synced</Badge>
            ) : (
              <Badge sx={{ color: "red" }}>Issue not synced</Badge>
            )}
            <br />
            {row.is_redeemed > 0 ? (
              <Badge sx={{ color: "green" }}>Redeemed</Badge>
            ) : (
              <Badge sx={{ color: "red" }}>Not redeemed</Badge>
            )}
            <br />
            {success_redeemed ? (
              <Badge sx={{ color: "green" }}>Redeem synced</Badge>
            ) : (
              <Badge sx={{ color: "red" }}>Redeem not synced</Badge>
            )}
          </>
        )}
        <br />
        {row.is_cancelled === 1 ? (
          <Badge sx={{ color: "red" }}>Cancelled</Badge>
        ) : !redeem && date > row.expiry_date ? (
          <Badge sx={{ color: "red" }}>Expired</Badge>
        ) : null}
      </>
    );
  };

  const PaymentStatus=()=>{
    const response = row.msg;
    const Paid = row.voucher_paid_status === "paid";

    
    return (
      <>
        {response === null ? (
          <Badge sx={{ color: "red" }}>No Response</Badge>
        ) : (
          <>
            {Paid ? (
              <Badge sx={{ color: "green" }}>paid</Badge>
            ) : (
              <Badge sx={{ color: "red" }}>unpaid</Badge>
            )}
            
          </>
        )}   
      </>
    );
  };
  const handleClickLink = (e, callback) => {
    e.preventDefault();
    callback(true);
  };

  // Use the fallback voucher id
  const voucherId = row.voucher_id || row.id;

  const renderCellContent = (columnId) => {
    switch (columnId) {
      case "status":
        return <VoucherStatus />;
      case "voucher_paid_status":
        return <PaymentStatus />;
      case "voucher_nr":
        return (
          <>
            <StaffVouchersShowVoucherNumber
              row={currentRow}
              setRow={setCurrentRow}
              redeem={redeem}
            />
            <br />
            {row.is_cancelled !== 1 && (
              <a
                href="#"
                onClick={(e) => handleClickLink(e, setShowCancelRedemption)}
                style={{
                  color: "#1976d2",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                Cancel Voucher
              </a>
            )}
            {showCancelRedemption && (
              <StaffVoucherCancelVoucher
                key={row.voucher_nr}
                open={showCancelRedemption}
                setOpen={setShowCancelRedemption}
                voucher={row}
                setLoadingVouchers={setLoadingVouchers}
              />
            )}
          </>
        );
      case "created_at":
        const formattedCreatedAt = row.created_at
          ? moment(row.created_at).format("DD/MM/YYYY")
          : "";
        return (
          <>
            {formattedCreatedAt}
            {!redeem && (
              <>
                <br />
                <a
                  href="#"
                  onClick={(e) => handleClickLink(e, setShowCreatedAtLogsManage)}
                  style={{
                    color: "#1976d2",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Edit Data
                </a>
                {showCreatedAtLogsManage && (
                  <LandingCommunityLogsUpdate
                    key={`${row.voucher_nr}-createdAt`}
                    open={showCreatedAtLogsManage}
                    setOpen={setShowCreatedAtLogsManage}
                    row={row}
                    mode={"issued"}
                    setLoadingVouchers={setLoadingVouchers}
                  />
                )}
              </>
            )}
          </>
        );
      case "transaction_date":
        if (row.transaction_date) {
          const formattedDate = moment(row.transaction_date).format("DD/MM/YYYY");
          if (redeem) {
            return (
              <>
                {formattedDate}
                <div>
                  <a
                    href="#"
                    onClick={(e) => handleClickLink(e, setShowCancelRedemption)}
                  >
                    Cancel redemption
                  </a>
                </div>
                {showCancelRedemption && (
                  <StaffVoucherCancelRedemption
                    key={row.voucher_nr}
                    open={showCancelRedemption}
                    setOpen={setShowCancelRedemption}
                    voucher={row}
                    setLoadingVouchers={setLoadingVouchers}
                  />
                )}
                <div>
                  <a
                    href="#"
                    onClick={(e) => handleClickLink(e, setShowLogsManage)}
                  >
                    Edit data
                  </a>
                </div>
                {showLogsManage && (
                  <LandingCommunityLogsUpdate
                    key={`${row.voucher_nr}-redeemed`}
                    open={showLogsManage}
                    setOpen={setShowLogsManage}
                    row={row}
                    mode={"redeemed"}
                    setLoadingVouchers={setLoadingVouchers}
                  />
                )}
              </>
            );
          } else {
            return formattedDate;
          }
        } else {
          return "";
        }
      case "a_date_surgery":
        return redeem && row.a_date_surgery
          ? moment(row.a_date_surgery).format("DD/MM/YYYY")
          : "";
      case "supplier_business_name":
        return (
          <>
            Vet: {row.supplier_name}
            <br />
            Email: {row.supplier_email || "n/a"}
            <br />
            Campaign: {row.campaign_name || "n/a"}
          </>
        );
      case "animal_species":
        return (
          <>
            {chip !== "" && redeem ? (
              <div>
                Chip#: {chip}&nbsp;
                <span>
                  <a
                    href="#"
                    onClick={(e) => handleClickLink(e, setIsOpenMC)}
                  >
                    Change
                  </a>
                </span>
                {isOpenMC && (
                  <StaffVouchersChangeVoucherNumber
                    open={isOpenMC}
                    setOpen={setIsOpenMC}
                    chip={chip}
                    setChip={setChip}
                    voucherId={voucherId}
                  />
                )}
              </div>
            ) : null}
            <button className="vet-info-button">
              Species: {row.animal_species}
            </button>
            <button className="vet-info-button">
              Sex: {row.animal_gender}
            </button>
            <button className="vet-info-button">Age: {row.a_age}</button>
            <button className="vet-info-button">
              Primary color: {row.a_color_primary}
            </button>
            {row.a_color_secondary && (
              <button className="vet-info-button">
                Secondary color: {row.a_color_secondary}
              </button>
            )}
          </>
        );
      case "owner_name":
        return redeem ? (
          <>
            <b>{row.owner_name}</b>
            <br />
            <span style={{ whiteSpace: "nowrap" }}>
              <MdEmail />{" "}
              <a
                href={"mailto:" + row.owner_email}
                target="_blank"
                rel="noopener noreferrer"
              >
                {row.owner_email}
              </a>
            </span>
            <br />
            <span style={{ whiteSpace: "nowrap" }}>
              <MdPhone /> {row.owner_phone_number}
            </span>
          </>
        ) : (
          ""
        );
      case "contact_name":
        return !redeem ? (
          <>
            <b>{row.contact_name}</b>
            <br />
            <span style={{ whiteSpace: "nowrap" }}>
              <MdEmail />{" "}
              <a
                href={"mailto:" + row.contact_email}
                target="_blank"
                rel="noopener noreferrer"
              >
                {row.contact_email}
              </a>
            </span>
            <br />
            <span style={{ whiteSpace: "nowrap" }}>
              <MdPhone /> {row.contact_phone_number}
            </span>
          </>
        ) : (
          ""
        );
      case "actions":
        return (
          <Button
            sx={{ margin: 0.5 }}
            variant={"contained"}
            onClick={() => setIsOpenRow(true)}
          >
            Details
          </Button>
        );
      default:
        return row[columnId] !== undefined && row[columnId] !== null
          ? String(row[columnId])
          : "";
    }
  };

  return (
    <>
      <TableRow key={row.id}>
      {version === "unused" && (
  < TableCell padding="checkbox">
    <Checkbox
      disabled={row.is_cancelled === 1}
      checked={row.is_cancelled !== 1 && selected}
      onChange={(e) => onSelectRow(voucherId, e.target.checked)}
    />
  </TableCell>
)}
        {columns.map((column) => (
          <TableCell key={column.id} align="left">
            {renderCellContent(column.id)}
          </TableCell>
        ))}
      </TableRow>
      <StaffVouchersDetailBox
        row={row}
        isOpen={isOpenRow}
        setIsOpen={setIsOpenRow}
      />
    </>
  );
}
